import { ProviderType } from "../../../../../../../services/cloudchipr.api";

export const tagLabels = new Map<ProviderType, string>([
  ["aws", "tags"],
  ["gcp", "labels"],
  ["azure", "tags"],
]);
